import React from 'react';
import { Image, Tooltip } from 'antd';
import './SwitchInfo.scss';

const SwitchInfo = ({
  imgSrc,
  title,
  list,
  curSelect,
  onSelect,
}: {
  imgSrc: string;
  title: string;
  list: { label: string; value: string }[];
  curSelect: string;
  onSelect: AnyFunc;
}) => {
  return (
    <div className='switch-info'>
      <div className='title'>
        <Image src={imgSrc} width={16} height={16} />
        <span>{title}</span>
      </div>
      {list.map((v) => {
        return (
          <Tooltip placement='topLeft' title={v.label}>
            <div
              className={v.value === curSelect ? 'item select' : 'item'}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                v.value !== curSelect && onSelect(v.value);
              }}
            >
              {v.label}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default React.memo(SwitchInfo);
